"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _auth = require("@/api/auth");
var _auth2 = require("@/utils/auth");
function getDefaultState() {
  return {
    info: {},
    token: ''
  };
}
var state = getDefaultState;
var mutations = {
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_INFO: function SET_INFO(state, info) {
    state.info = info;
  }
};
var actions = {
  login: function login(_ref, _ref2) {
    return (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
      var commit, password, username, res;
      return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              password = _ref2.password, username = _ref2.username;
              _context.next = 4;
              return _auth.authApi.login({
                password: password,
                username: username
              });
            case 4:
              res = _context.sent;
              (0, _auth2.setToken)(res.data.token);
              commit('SET_TOKEN', res.data.token);
            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  getInfo: function getInfo(_ref3) {
    return (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
      var commit, res, data, token;
      return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref3.commit;
              _context2.next = 3;
              return _auth.authApi.profile();
            case 3:
              res = _context2.sent;
              data = res.data;
              commit('SET_INFO', data);
              token = (0, _auth2.getToken)();
              commit("SET_TOKEN", token);
            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  logout: function logout(_ref4) {
    var commit = _ref4.commit;
    commit("SET_TOKEN", "");
    (0, _auth2.removeToken)();
  }
};
var getters = {
  token: function token(state) {
    return state.token;
  }
};
var _default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};
exports.default = _default;